import React from "react";

import AttendanceModule from "./attendanceModule";
import MarketingModule from "./marketingModule";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";
import MembershipRevenueModule from "./membershipRevenueModule";
import MembershipUnitsModule from "./membershipUnitsModule";
import TotalRevenueModule from "./totalRevenueModule";
import LeadsAddedModule from "./leadsAddedModule";
import FirstRidersModule from "./firstRidersModule";
import dashboardFilters from "./dashboardFilters";
import AIAgent from "../ai";

const pageConfig = {
  pageName: "Dashboard",
  configuratorWidth: 350,
  pageFilters: [dashboardFilters],
  moduleList: [
    AttendanceModule,
    MarketingModule,
    MembershipRevenueModule,
    MembershipUnitsModule,
    TotalRevenueModule,
    LeadsAddedModule,
    FirstRidersModule
  ]
};

const DashboardPage = ({ notifications, objectId }) => {
  const PageFilters = dashboardFilters.Component;

  return (
    <PageWithConfigurator
      pageConfig={pageConfig}
      notifications={notifications}
      renderFilters={() => <PageFilters />}
      renderAI={() => <AIAgent pageName="main_dash" widget objectId={objectId} />}
    />
  );
};

export default DashboardPage;
